// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingNew_loadingContainer__15f5U","animationContainer":"LoadingNew_animationContainer__AJ1TC","animation":"LoadingNew_animation__69688"};